export const BurgerMenuIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.42188 15.2617H6.98812'
        stroke='currentColor'
        strokeWidth='1.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.42188 10H12.7069'
        stroke='currentColor'
        strokeWidth='1.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.42188 4.73828H18.5781'
        stroke='currentColor'
        strokeWidth='1.7'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
